import React, { useEffect, useState } from 'react';
import { ROLES, ROLE_PERMS, RESTRICTED_LAYERS_BY_ROLE } from './RoleSwitcher';

/**
 * Pops a slide-down banner whenever the user switches role, summarizing
 * the new permissions. Auto-dismisses after 5s; user can dismiss earlier.
 */
export default function RoleToast() {
  const [visible, setVisible] = useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const onChange = (e) => {
      const id = e.detail || (typeof window !== 'undefined' && window.localStorage.getItem('nexus_demo_role')) || 'admin';
      const r = ROLES.find((x) => x.id === id) || ROLES[0];
      setRole(r);
      setVisible(true);
    };
    window.addEventListener('nexus-role-change', onChange);
    return () => window.removeEventListener('nexus-role-change', onChange);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible || !role) return null;

  const perms = ROLE_PERMS[role.id] || [];
  const blockedLayers = RESTRICTED_LAYERS_BY_ROLE[role.id] || [];

  return (
    <div style={overlay}>
      <div style={{ ...banner, borderLeft: `4px solid ${role.color}` }}>
        <div style={{ flex: '0 0 36px', height: 36, borderRadius: 18, background: role.color + '22', color: role.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700 }}>
          {role.icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>Now logged in as</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: role.color }}>{role.label}</div>
            <div style={{ fontSize: 11, color: '#64748b', fontFamily: 'ui-monospace, monospace' }}>· {role.user}</div>
          </div>
          <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {['read', 'write', 'export', 'import', 'annotate', 'onboard', 'admin'].map((p) => (
              <span
                key={p}
                style={{
                  fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10,
                  background: perms.includes(p) ? '#dcfce7' : '#fee2e2',
                  color:      perms.includes(p) ? '#166534' : '#991b1b',
                  textTransform: 'uppercase', letterSpacing: '0.04em'
                }}
              >
                {perms.includes(p) ? '✓' : '✗'} {p}
              </span>
            ))}
          </div>
          {blockedLayers.length > 0 && (
            <div style={{ marginTop: 6, fontSize: 11, color: '#64748b' }}>
              Hidden layers: <span style={{ color: '#dc2626', fontFamily: 'ui-monospace, monospace' }}>{blockedLayers.join(', ')}</span>
            </div>
          )}
        </div>
        <button onClick={() => setVisible(false)} style={closeBtn} aria-label="Dismiss">×</button>
      </div>
    </div>
  );
}

const overlay = {
  position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
  zIndex: 10000, width: 'min(560px, calc(100% - 32px))',
  animation: 'slideDown 220ms ease-out'
};
const banner = {
  background: 'white', borderRadius: 8,
  boxShadow: '0 12px 32px rgba(0,0,0,0.18)',
  padding: '14px 16px',
  display: 'flex', alignItems: 'flex-start', gap: 12,
  fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif'
};
const closeBtn = {
  background: 'transparent', border: 'none', fontSize: 24, color: '#94a3b8',
  cursor: 'pointer', lineHeight: 1, padding: 0, marginLeft: 4
};
